import { createMemo } from 'solid-js';
import { gameStore } from '../../store/gameStore';

export default function OnlineCounter() {
  const online = createMemo(() => gameStore.onlinePlayers());
  const count = createMemo(() => online()?.totalOnline ?? 0);

  return (
    <div class="online-counter-frame" aria-live="polite" title="Online players">
      <span class="online-counter-icon" aria-hidden="true">👤</span>
      <span class="online-counter-value">{count().toLocaleString()}</span>
      <span class="online-counter-label">online</span>
    </div>
  );
}
